/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 07/12/22
 */

import { BreadCrumbItem } from '@/components/BreadCrumb';

export interface AllUsersInterface {
    firstName?: string;
    lastName?: string;
    assignmentId?: string;
}

export const getUserListFromParam = (userDetails: string): AllUsersInterface[] => {
    return userDetails
        .split(';')
        .filter(Boolean)
        .map((user) => ({
            firstName: user?.split('-')[0],
            lastName: user?.split('-')[1],
            assignmentId: user?.split('-')[2],
        }));
};

export const generateUserBreadcrumbs = (users: AllUsersInterface[], params = '') => {
    return users
        .reduce((acc, user) => {
            return [
                ...acc,
                {
                    label: `${user.firstName} ${user.lastName}`,
                    path:
                        acc.length === 0
                            ? `${user.firstName}-${user.lastName}-${user.assignmentId};`
                            : `${acc[acc.length - 1].path}${user.firstName}-${user.lastName}-${user.assignmentId};`,
                    id: user.assignmentId,
                    isCurrent: false,
                },
            ];
        }, [] as (BreadCrumbItem & { id?: string })[])
        .map((b) => ({
            ...b,
            path: `/admin/user/supervision/detail/${b.path}/${b.id}?${params}`,
        }));
};
